import api from '../api';
import { GetMembershipsResponse } from '@ilteducation/customer-mgmt-types';
import { ref } from 'vue';

export const useGetUserGroups = () => {
  const groups = ref<GetMembershipsResponse | null>(null);
  const error = ref<null | unknown>(null);
  const isLoading = ref<boolean>(false);

  const loadUserGroups = async (userUid: string, organizations: string[]) => {
    try {
      isLoading.value = true;
      groups.value = null;
      const request = (pageNumber: number) =>
        api.memberships.get({
          pageSize: 100,
          pageNumber,
          sortBy: 'groupName',
          sortOrder: 'asc',
          filters: {
            users: [userUid],
            groupSchoolUnits: organizations,
          },
        });

      const response = await request(1);

      const { meta, data } = response.data;

      const leftMemberships = (meta.totalItems ?? 0) - data.length;
      if (leftMemberships > 0) {
        const requests = Array.from({ length: Math.ceil(leftMemberships / 100) }, (_, index) => request(index + 2));
        await Promise.all(requests).then((responses) => {
          responses.forEach((response) => data.push(...response.data.data));
        });
      }

      groups.value = { meta, data };
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }

    return groups.value;
  };

  return {
    loadUserGroups,
    isLoading,
    groups,
    error,
  };
};
